var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreenstar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 7.16 7.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#radial-gradient);}.cls-2{opacity:0.7;}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 3.58,
    cy: 3.58,
    r: 3.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#3b9645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#53a449"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#91c653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#96c954"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#89c658"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#71b752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#3b9645"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WATER-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PL_2",
    "data-name": "PL 2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 3.58,
    cy: 3.58,
    r: 3.58
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "3.58 1.34 4.31 2.81 5.93 3.05 4.76 4.2 5.04 5.82 3.58 5.05 2.12 5.82 2.4 4.2 1.22 3.05 2.85 2.81 3.58 1.34"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenstar);
export default __webpack_public_path__ + "static/media/greenstar.016e278b08fb0d9aa3a464785e448233.svg";
export { ForwardRef as ReactComponent };